// Surface reduction phase 2 removed the THIRA feature, so the THIRA / THIRAs /
// THIRA-subtitle keys are gone. strs() falls back to returning the key itself,
// so any straggling caller degrades to the literal string rather than throwing.
const strings = {
  Assumptions: {
    government: 'Assumptions',
    corporate: 'Assumptions',
  },
  Assumption: {
    government: 'Assumption',
    corporate: 'Assumption',
  },
  Evidence: {
    government: 'Evidence',
    corporate: 'Evidence',
  },
  EvidenceItem: {
    government: 'Evidence Item',
    corporate: 'Evidence Item',
  },
  'Critical Assumption': {
    government: 'Critical Assumption',
    corporate: 'Critical Assumption',
  },
  'Important Assumption': {
    government: 'Important Assumption',
    corporate: 'Important Assumption',
  },
  'Supporting Assumption': {
    government: 'Supporting Assumption',
    corporate: 'Supporting Assumption',
  },
  'Assumption-Freshness-Settings-title': {
    government: 'Assumption Freshness Windows',
    corporate: 'Assumption Freshness Windows',
  },
  'Assumption-Freshness-Settings-subtitle': {
    government:
      'Set how many days an assumption remains fresh before it is automatically marked stale. Critical assumptions require more frequent validation.',
    corporate:
      'Set how many days an assumption remains fresh before it is automatically marked stale. Critical assumptions require more frequent validation.',
  },
  CriticalDependencies: {
    government: 'Critical Dependencies',
    corporate: 'Critical Dependencies',
  },
  CriticalDependency: {
    government: 'Critical Dependency',
    corporate: 'Critical Dependency',
  },
  TrackRecord: {
    government: 'Track Record',
    corporate: 'Track Record',
  },
  ActiveRegression: {
    government: 'Active Regression',
    corporate: 'Active Regression',
  },
  RevalidationPack: {
    government: 'Revalidation Pack',
    corporate: 'Revalidation Pack',
  },
}

export function strs(key, org) {
  const type = org?.organizationType || 'government'
  return strings[key]?.[type] ?? key
}
